export const PREFETCH_VALID_TIME_IN_MILLISECOND: number = 3600000; // 1 hour

export interface BasePreviewInformation {
    lastUpdateTime: Date;
}

export interface TextContent extends BasePreviewInformation {
    Content: string;
}

export interface FilePreviewUrl extends BasePreviewInformation {
    previewUrl: string;
}

export type PreviewInformation = TextContent | FilePreviewUrl;
